export default function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}


// WEBPACK FOOTER //
// /Users/stephen.tait/Local Sites/storyiq/app/public/web/wp-content/themes/jaywing/node_modules/swiper/core/translate/maxTranslate.js